import bowser from 'bowser';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';


export default function isBrowserSupported() {
    const blacklistedBrowsers = appConfig.browserBlacklist;
    const browser = bowser.getParser(navigator.userAgent);
    const currentBrowser = browser.getBrowserName();
    const browserConfigExists = currentBrowser in blacklistedBrowsers;
    let browserSupported = !browserConfigExists;

    if (browserConfigExists) {
        const unsupportedVersion = blacklistedBrowsers[currentBrowser];
        browserSupported = browser.compareVersion(`>${unsupportedVersion}`);
    }

    return browserSupported;
}
